import React, { useState } from 'react'; // Importe useState
import './Header.css';
import logoImage from '../../assets/logo (2).png';

function Header() {
  const [isMenuOpen, setIsMenuOpen] = useState(false); // Novo estado para controlar o menu

  const handleScroll = (id) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
      setIsMenuOpen(false); // Fecha o menu ao clicar em um item
    }
  };

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen); // Alterna o estado do menu
  };

  return (
    <header className="header">
      <div className="logo">
        <img src={logoImage} alt="DLOGIC Logo" className="logo-img" />
      </div>

      {/* Botão para o menu hambúrguer - visível apenas em mobile */}
      <button className="menu-toggle" onClick={toggleMenu} aria-label="Abrir menu de navegação">
        <div className={`hamburger ${isMenuOpen ? 'open' : ''}`}></div>
        <div className={`hamburger ${isMenuOpen ? 'open' : ''}`}></div>
        <div className={`hamburger ${isMenuOpen ? 'open' : ''}`}></div>
      </button>

      {/* Adicione a classe 'open' ao nav quando o menu estiver aberto */}
      <nav className={`nav ${isMenuOpen ? 'open' : ''}`}>
        <ul>
          <li><button onClick={() => handleScroll('sobre-projeto')}>Sobre o projeto</button></li>
          <li><button onClick={() => handleScroll('area-aplicacao')}>Área de aplicação</button></li>
          <li><button onClick={() => handleScroll('nossa-equipe')}>Nossa equipe</button></li>
          <li><button onClick={() => handleScroll('ferramentas')}>Ferramentas</button></li>
          <li>
            <a
              href="/DocumentaçãoDLOGIC.pdf"
              target="_blank"
              rel="noopener noreferrer"
              className="doc-button"
            >
              Documentação
            </a>
          </li>
        </ul>
      </nav>
    </header>
  );
}

export default Header;
